import { addDays, getMonday, formatDate } from "../../utils/dateUtils";
import Button from "../ui/Button";

export default function CalendarNavigation({ weekStart, setWeekStart, weekDates, getMonday, addDays, formatDate }) {
  return (
    <div className="flex items-center justify-center gap-2 sm:gap-4 mb-3 text-xs sm:text-sm">
      <Button
        variant="secondary"
        size="sm"
        onClick={() => setWeekStart(addDays(weekStart, -7))}
      >
        ←
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={() => setWeekStart(getMonday(new Date()))}
      >
        {formatDate(weekDates[0])} - {formatDate(weekDates[weekDates.length - 1])}
      </Button>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => setWeekStart(addDays(weekStart, +7))}
      >
        →
      </Button>
    </div>
  );
}
